import { PersistedOrderPayload } from '@onesunday/domain';
import { format } from 'date-fns';

// Stripe-style status pills — soft pastel bg + dark accessible text.
// All pairs hit WCAG AA at 14px text on the pastel background.
export const STATUS_STYLES: Record<
  string,
  {
    bg: string;
    text: string;
    border: string;
    chart: string;
    chartFocused: string;
  }
> = {
  Pending: {
    bg: 'bg-[#F0F4F8]',
    text: 'text-[#414D5C]',
    border: 'border-[#F0F4F8]',
    chart: '#8792A2',
    chartFocused: '#414D5C',
  },
  Verifying: {
    bg: 'bg-[#EAEEFE]',
    text: 'text-[#3F1DCB]',
    border: 'border-[#EAEEFE]',
    chart: '#5B5FE9',
    chartFocused: '#3F1DCB',
  },
  Paid: {
    bg: 'bg-[#EFF6FF]',
    text: 'text-[#0469C7]',
    border: 'border-[#EFF6FF]',
    chart: '#0570DE',
    chartFocused: '#0469C7',
  },
  Ready: {
    bg: 'bg-[#D7F7E1]',
    text: 'text-[#0E6245]',
    border: 'border-[#D7F7E1]',
    chart: '#0E9F6E',
    chartFocused: '#0E6245',
  },
  Completed: {
    bg: 'bg-[#F0F4F8]',
    text: 'text-[#697386]',
    border: 'border-[#E3E8EE]',
    chart: '#8792A2',
    chartFocused: '#697386',
  },
  Late: {
    bg: 'bg-[#FDE2DD]',
    text: 'text-[#A41C2C]',
    border: 'border-[#FDE2DD]',
    chart: '#DC2626',
    chartFocused: '#A41C2C',
  },
};

export const MENU_ITEMS = [
  {
    id: 'dangerously-delicious-wings',
    name: 'Dangerously Delicious Wings',
    price: 175,
    color: '#E58A4E',
  },
  {
    id: 'the-butter-affair-chicken',
    name: 'Robertsons Zesty Sunday Chicken',
    price: 250,
    color: '#E9A24B',
  },
  {
    id: 'the-wagyu-way-burger',
    name: 'The Brisket Burger',
    price: 220,
    color: '#F6C24D',
  },
  {
    id: 'ribs-n-revelation',
    name: 'Ribs n Revelation',
    price: 375,
    color: '#C9573A',
  },
  {
    id: 'dalis-danger-platter',
    name: "Dali's Danger Platter for 5",
    price: 680,
    color: '#7D4B35',
  },
  {
    id: 'wagyulicious-burger-platter',
    name: 'The Brisket Burger Platter',
    price: 900,
    color: '#5E9F45',
  },
] as const;

export const DEFAULT_GRAPH_HOURS = ['14:00', '15:00', '16:00', '17:00', '18:00'];

export const CAMPAIGN_DETAILS = {
  controlTitle: import.meta.env.VITE_ADMIN_TITLE || 'One Sunday Campaign Control Center',
  campaignName: import.meta.env.VITE_CAMPAIGN_NAME || 'One Sunday · 6 September 2026',
  pickupWindow: import.meta.env.VITE_PICKUP_WINDOW || '',
  pickupLocation: import.meta.env.VITE_PICKUP_LOCATION || '',
  contactNumber: import.meta.env.VITE_CONTACT_NUMBER || '',
  description: import.meta.env.VITE_CAMPAIGN_DESCRIPTION || '',
};

export const getOrderTargetDate = (order: PersistedOrderPayload): Date => {
  return order.createdAt ? new Date(order.createdAt) : new Date();
};

export const getOrderHourLabel = (order: PersistedOrderPayload) =>
  format(getOrderTargetDate(order), 'HH:00');

export const statusPriority: Record<string, number> = {
  Pending: 0,
  Verifying: 1,
  Paid: 2,
  Ready: 3,
  Late: 4,
  Completed: 5,
};
